module.exports = __webpack_public_path__ + "img/user.18abe889.svg";